// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import OthersUserTable from './others-table';
// assets
//

// ----------------------------------------------------------------------

export default function OthersAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <OthersUserTable />
        </Container >
    );
}
